// extracted by mini-css-extract-plugin
export default {"searchTypeSelector":"S4FatJfFvoMaHtwKTLNo"};